import React, { useCallback, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation, Trans } from 'react-i18next';
import { themeColor } from '../Theming';
import { useQuery } from '../Common/Hooks';
import CashSaverBrands from '../ITVActivation/Components/CashSaverBrands';

const SubTitleTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
`;

const SubTitleText = styled.div`
  color: ${themeColor('darkestGrey')};
  text-align: center;
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  width: 220px;
`;

const LinkText = styled.a`
  color: ${themeColor('blue')};
`;

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ListContent = styled.li`
  color: ${themeColor('darkestGrey')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin-left: 15px;
  margin-bottom: 20px;
`;

const BorderedItem = styled.strong`
  color: ${themeColor('blue')};
  border: 0.8px solid ${themeColor('blue')};
  padding: 3px;
  border-radius: 5px;
  margin-left: 3px;
`;

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
`;

const StyledImage = styled.img`
  position: fixed;
  top: 8px;
  right: 20px;
  animation: ${bounce} 2s infinite;
  width: 163px;
  height: 46px;
`;

const MultiStepStyledButton = styled.button`
  flex-shrink: 0;
  color: ${themeColor('white')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background-color: black;
  width: 254px;
  height: 42px;
  border-radius: 5px;
`;

const CashSaverBrandsContainer = styled.div`
  width: 100%;
  padding-bottom: 20px;
  overflow-x: scroll; /* Enables horizontal scrolling */
  overflow-y: hidden;
`;

const FrequentlyAskedQuestion = styled.div`
  color: #000;

  text-align: center;
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
  text-decoration-line: underline;
  margin-top: 10px;
`;
const PartnerNewPluginActivateMultiStepAllDone = () => {
  const { t } = useTranslation();
  const query = useQuery();

  const openApp = useCallback(() => {
    const origin = query.get('origin');
    if (origin)
      window.location = `${origin}://` as (string | Location) & Location;
  }, [query]);

  return (
    <MultiStepActivationContainer
      bodyMarginTop={10}
      headerText={'PartnerNewpluginsdkActivate.allDoneSeeYouAtCheckout'}
    >
      <SubTitleTextContainer>
        <SubTitleText>
          <Trans
            t={t}
            i18nKey={'PartnerNewpluginsdkActivate.cashSaverWillPopup'}
          >
            <LinkText>AbsoluteText</LinkText>
          </Trans>
        </SubTitleText>
      </SubTitleTextContainer>
      <BodyContentContainer>
        <CashSaverBrandsContainer>
          <CashSaverBrands noPaddingTop={true} />
        </CashSaverBrandsContainer>
        <MultiStepStyledButton onClick={openApp}>
          {t('PartnerNewpluginsdkActivate.backToApp')}
        </MultiStepStyledButton>
        <FrequentlyAskedQuestion>
          {t('PartnerNewpluginsdkActivate.frequentlyAskedQuestions')}
        </FrequentlyAskedQuestion>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerNewPluginActivateMultiStepAllDone;
